// src/hooks/useCurrencyOptions.ts
import { useFetchCurrenciesQuery } from '@pages/Pricers/store/pricerPreLoad/pricerPreLoadReducer';
import { useMemo } from 'react';

import { currencySymbols } from './currencySymbols';

export interface CurrencyOption {
  value: string;
  label: string;
  flag: string;
  description: string;
  id: number;
}

const useCurrencyOptions = () => {
  const { data: currencies = [] } = useFetchCurrenciesQuery();

  return useMemo(
    () =>
      (currencies || []).map((cur) => {
        const code = cur.currency_code;
        const flag = currencySymbols[code] || '';
        return {
          value: code,
          label: `${flag} ${code}`,
          flag,
          description: cur.description,
          id: cur.currency_id,
        };
      }),
    [currencies],
  );
};

export default useCurrencyOptions;
